// extracted by mini-css-extract-plugin
var _1 = "t2NO";
var _2 = "t2NN";
var _3 = "t2NO";
var _4 = "t2NN";
export { _1 as "pos-abs", _2 as "pos-rel", _3 as "posAbs", _4 as "posRel" }
